import { useEffect, useRef } from 'react'

export const useInitialEmailVerification = (
  showVerifyForm: boolean,
  email: string,
  resendVerification: (email: string) => void,
): void => {
  const requestedEmailRef = useRef<string>()

  useEffect((): void => {
    if (!showVerifyForm) {
      requestedEmailRef.current = undefined
      return
    }

    if (requestedEmailRef.current === email) return

    requestedEmailRef.current = email
    resendVerification(email)
  }, [email, resendVerification, showVerifyForm])
}
